'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';
import React from 'react'
import PaginationPluto from './Pagination';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import { useEffect } from 'react';
import { useState } from 'react';
import PlutoMenu from './PlutoMenu';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';

function PlutoWithdrawalsToday() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [length, setLength] = useState(0)
    const [rank, setRank] = useState(0)
    const [uid, setUID] = useState(-1)
    useEffect(() => {
        socket.on('response_get_admin_withdrawalstoday', (data) => {
            setEarnings(data.users)
            setPageNumber(Math.ceil(data.usersLength / 10))
            setLength(data.usersLength)
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)
            setUID(data.uid);

        })
        socket.emit('getWithdrawalsAdminToday', {
            username_like: username,
            page,
        })
    }, [])

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh' }}>
                <div className="user-details-stats" style={{ padding: '20px' }}>

                    {length != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #d29922',
                            borderRadius: '12px',
                            padding: '16px 20px',
                            display: 'inline-block'
                        }}>
                            <p style={{ color: '#e6edf3', fontSize: '24px', fontWeight: 700, margin: '0 0 4px 0' }}>
                                {numberWithCommas(length)}
                            </p>
                            <p style={{ color: '#8b949e', fontSize: '13px', margin: 0 }}>Flagged/Review Today</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                <div style={{
                    overflow: 'auto',
                    margin: '0 auto',
                    padding: '20px',
                    marginBottom: '20px',
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px'
                }}>
                    <p style={{ color: '#e6edf3', fontWeight: 'bold', fontSize: '16px', marginBottom: '16px' }}>Users</p>

                    <div style={{ fontWeight: 'bold' }}>
                        <div className="user-details-table-elements" style={{ borderBottom: '1px solid #21262d', paddingBottom: '8px', marginBottom: '4px' }}>

                            <div style={{ minWidth: '50px', textAlign: 'left', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }} >UID</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Amount</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Flagged</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Review</div>
                            <div style={{ minWidth: '100px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Date</div>
                        </div>
                    </div>

                    {earnings.map((earning, i) => {
                        return (
                            <Link to={`/pluto/user/${earning.user_id}`} key={earning.id} className="user-details-table-elements admin-a" style={{
                                color: '#c9d1d9',
                                textDecoration: 'none',
                                borderBottom: '1px solid #21262d',
                                padding: '10px 0',
                                transition: 'background 0.2s'
                            }}>

                                <div style={{ minWidth: '200px', color: '#e6edf3' }} >{earning.username == undefined ? '' : earning.username || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px', color: '#c9d1d9' }} >{earning.balance || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px', color: '#c9d1d9' }} >{earning.status || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px', color: '#c9d1d9' }} >{earning.review || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px', color: '#8b949e' }} >{earning.date || <Skeleton style={{ width: '30px' }} />}</div>

                            </Link>
                        )
                    })}
                </div>
                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                    socket.emit('getWithdrawalsAdminToday', {
                        username_like: username,
                        page,
                    })
                }} />}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 0' }}>
                    <input onKeyDown={
                        (e) => {
                            if (e.key == 'Enter') {
                                canUsePagination(false)
                                setEarnings([0, 0, 0, 0, 0])
                                socket.emit('getWithdrawalsAdminToday', {
                                    username_like: username,
                                    page: document.getElementById('jumpto3dwithdrawalstoday').value,
                                })
                            }
                        }

                    } type="number" id="jumpto3dwithdrawalstoday" style={{
                        background: '#0d1117',
                        color: '#e6edf3',
                        border: '1px solid #30363d',
                        borderRadius: '6px',
                        padding: '6px 10px',
                        outline: 'none',
                        width: '80px'
                    }} />
                    <button onClick={() => {
                        canUsePagination(false)
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        socket.emit('getWithdrawalsAdminToday', {
                            username_like: username,
                            page: document.getElementById('jumpto3dwithdrawalstoday').value,
                        })
                    }
                    } style={{
                        color: '#ffffff',
                        background: '#238636',
                        border: '1px solid #2ea043',
                        borderRadius: '6px',
                        padding: '6px 14px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 500
                    }}>Go to page</button>
                </div>
            </div>

        </SkeletonTheme>
    )
}

export default PlutoWithdrawalsToday
